var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import AppBar from '@material-ui/core/AppBar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import { IconList } from './IconList';
import { MobileMenu } from './MobileMenu';
const useStyles = makeStyles({
    root: {
        backgroundColor: 'black',
        flexGrow: 1
    }
});
const AppNavbar = (props) => {
    const [mobileMenuAnchorEl, setMobileMoreAnchorEl] = useState(null);
    const mobileMenuId = 'app-nav-bar-mobile-icons-menu';
    const { logout, currentUser, help, home, infoToolTipTitle, alt, children, classes } = props, appBarProps = __rest(props, ["logout", "currentUser", "help", "home", "infoToolTipTitle", "alt", "children", "classes"]);
    const mergedClasses = useStyles({ classes });
    const handleMobileMenuClose = () => setMobileMoreAnchorEl(null);
    const handleMobileMenuOpen = (event) => setMobileMoreAnchorEl(event.currentTarget);
    return (React.createElement(React.Fragment, null,
        React.createElement(IntlProvider, { locale: 'en' },
            React.createElement(AppBar, Object.assign({ position: 'static', classes: mergedClasses }, appBarProps),
                React.createElement(IconList, { home: home, help: help, infoToolTipTitle: infoToolTipTitle, currentUser: currentUser, logout: logout, mobileMenuId: mobileMenuId, mobileMenuAnchorEl: mobileMenuAnchorEl, onMobileMenuOpen: handleMobileMenuOpen, onMobileMenuClose: handleMobileMenuClose, alt: props.alt }, props.children)),
            React.createElement(MobileMenu, { home: home, help: help, infoToolTipTitle: infoToolTipTitle, currentUser: currentUser, logout: logout, mobileMenuId: mobileMenuId, mobileMenuAnchorEl: mobileMenuAnchorEl, onMobileMenuOpen: handleMobileMenuOpen, onMobileMenuClose: handleMobileMenuClose }))));
};
export default AppNavbar;
//# sourceMappingURL=AppNavbar.js.map